// @core/api/endpoints/workflow/list_test_results.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTestResultsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List test results
 * Returns test results for a pipeline, optionally filtered by test case or status.
 */
export async function ListTestResults(
  pipeline_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTestResultsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/test-results`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.get<ListTestResultsResponse>(requestPath, { ...requestOptions, params });
}
